import { Stack } from "@ui/components/Stack";
import { Typography } from "@ui/components/Typography";
import type { ReactNode } from "react";
import React from "react";
import type { BsPrefixProps, BsPrefixRefForwardingComponent } from "react-bootstrap/esm/helpers";

export interface IconTextBlockProps extends BsPrefixProps, React.HTMLAttributes<HTMLElement> {
	icon: ReactNode;
	title: string;
}

export const IconTextBlock: BsPrefixRefForwardingComponent<"div", IconTextBlockProps> = React.forwardRef<
	HTMLElement,
	IconTextBlockProps
>(({ icon, title, children, ...props }, ref) => {
	return (
		<Stack ref={ref} direction="horizontal" gap={4} {...props}>
			<div className="text-primary icon-4">{icon}</div>
			<div>
				<Typography variant="h2" gutterBottom>
					{title}
				</Typography>
				<Typography variant="body">{children}</Typography>
			</div>
		</Stack>
	);
});
